import { Product } from '@/creditflowresearch/domain/Product';
import { AbsProduct } from '@/creditflowresearch/domain/Product';
import { LEAGUE_TABLE } from '@/creditflowresearch/domain/Header/Tool/constants';
import { ITool, BADGE_TYPES } from '@/creditflowresearch/domain/vo/ITools';

export type BadgeRule = (tool: ITool, productId: string) => string | null;

class ToolBadgeResolver {
  private static readonly RULES: BadgeRule[] = [
    (tool, productId) => {
      if (tool.beta) return BADGE_TYPES.BETA;

      const isLeagueTableForNonAbs =
        tool.id === LEAGUE_TABLE &&
        !Product.isOfType(productId, AbsProduct.TYPE);

      return isLeagueTableForNonAbs ? BADGE_TYPES.BETA : null;
    },
    (tool) => tool.new ? BADGE_TYPES.NEW : null,
    (tool) => tool.pro ? BADGE_TYPES.PRO : null,
  ];

  static resolve(tool: ITool, productId: string): string[] {
    return ToolBadgeResolver.RULES
      .map((rule) => rule(tool, productId))
      .filter((badge): badge is string => badge !== null);
  }

  static registerRule(rule: BadgeRule): void {
    ToolBadgeResolver.RULES.push(rule);
  }
}

export default ToolBadgeResolver;
